import { memo, useEffect, useState } from "react";
import Select from "react-select";
import "./Header.css";

const options = [
  { value: "en", label: "English" },
  { value: "ar", label: "العربية" },
  { value: "ru", label: "Pусский" },
  { value: "es", label: "Español" },
  { value: "tr", label: "Türkçe" },
  { value: "vi", label: "Tiếng Việt" },
];

function updateLanguageInURL(lang) {
  const url = new URL(window.location.href);
  url.searchParams.set("lang", lang);
  window.history.pushState({}, "", url);
}

const Header = ({ language, setLanguage }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    setSelectedOption(options.find((option) => option.value === language));
  }, [language]);

  const onChangeHandle = (selectedOption) => {
    setSelectedOption(selectedOption);
    setLanguage(selectedOption.value);
    updateLanguageInURL(selectedOption.value);
  };

  return (
    <header className="app-header">
      <div className="app-header-content">
        <a href="https://tango.me" target="_blank" rel="noreferrer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="127"
            height="48"
            fill="none"
            viewBox="0 0 127 48"
            className="cbHHe"
          >
            <path
              fill="url(#svg-3937310671__a)"
              d="M35.32 14.158c-1.357.34-6.106 1.018-8.31 1.315-2.079 1.795-5.48 5.309-2.46 5.003 3.774-.381 9.625-1.653 12.254-2.544 1.4-.474 1.624-2.202.933-3.095-.607-.786-1.623-.877-2.417-.679"
            ></path>
            <path
              fill="url(#svg-3937310671__b)"
              d="M7.376 18.738c.584 3.066 5.456 3.024 7.845 2.756-1.074 1.597-3.375 6.055-3.986 11.11-.763 6.317 3.604 12.77 11.788 12.423 6.997-.296 13.145-6.657 16.452-10.77s.976-7.378-.297-8.608-5.427-2.671-8.353 2.163-6.954 8.056-9.413 7.42-.848-5.47 0-7.42 7.505-14.714 9.074-18.19c2.332-4.453-1.924-8.358-5.512-5.853a573 573 0 0 1-14.205 9.583c-1.837 1.191-3.977 2.32-3.393 5.386"
            ></path>
            <path
              fill="url(#svg-3937310671__c)"
              d="m25.106 20.415.096-.19c.817-1.606 1.669-3.282 2.455-4.84 2.379-.328 6.427-.918 7.663-1.227.793-.198 1.81-.107 2.417.679.69.893.466 2.621-.933 3.095-2.503.848-7.927 2.042-11.698 2.483"
            ></path>
            <path
              fill="url(#svg-3937310671__d)"
              d="M9.25 20.906c3.469-.75 7.031-2.906 9.406-4.84-1.625 2.59-3.406 5.403-3.406 5.403-1.145.127-3.795.328-6-.563"
            ></path>
            <path
              fill="currentColor"
              d="M56.352 13.624c-1.321 1.513-1.931 2.063-3.375 3.026-1.746 1.163-2.677 1.28-3.375 1.862-.626.521-.673 1.472-.466 2.095.335 1.006 1.862 1.163 2.922 1.095-.908 1.598-1.515 3.692-1.76 5.237-.528 3.343 1.02 5.77 5.19 5.155 1.283-.19 3.328-1.19 4.356-2.526 1.163-1.513.698-2.843-.35-3.608-.736-.537-1.683-.18-2.403.603-.623.677-1.205 1.344-1.994 1.125-1.603-.445 1.197-6.248 1.197-6.248s3.487-.346 4.987-.909c.937-.351 1.547-1.619 1.031-2.437-.288-.458-.875-.756-1.406-.657-1.5.282-3.062.544-3.062.544s.8-1.705 1.069-2.379c.741-1.862-1.35-3.364-2.561-1.978M67.06 21.313c-.536.365-1.27.394-1.73-.063l-.42-.416c-.557-.545-.562-1.501.084-1.938a9.9 9.9 0 0 1 4.287-1.614c1.47-.196 2.933-.133 4.36.287.666.196 1.275.511 1.778 1.008.553.553.833 1.239.924 2.009.105.854-.07 1.68-.252 2.505-.533 2.481-1.072 4.962-1.602 7.443a1.364 1.364 0 0 1-1.326 1.092h-.168q-.583 0-1.168.002a1.207 1.207 0 0 1-1.206-1.224c.003-.193.004-.377.004-.524-.02.014-.049.014-.063.028-1.127 1.029-2.47 1.581-3.947 1.861-.798.154-1.61.21-2.415.07-1.113-.195-2.037-.7-2.583-1.735-.37-.707-.433-1.463-.335-2.247.23-1.812 1.301-3.002 2.855-3.821 1.127-.595 2.492-1.054 3.737-1.3 1.365-.272 2.583-.303 3.97-.373.181-.007.244-.07.258-.252.09-1-.476-1.714-1.526-1.847-1.314-.162-2.486.348-3.516 1.05m4.412 3.57c-.804.065-1.41.133-2.093.238-.825.133-1.63.35-2.38.735-.433.224-.832.496-1.112.91-.703 1.05.125 1.878 1.406 1.674 1.745-.28 3.84-1.397 4.179-3.557M91.74 34.635c-.575-.686-.252-1.686.537-2.107l.732-.39c.697-.372 1.51-.135 2.1.39.529.47 1.145.798 1.871.88 1.52.167 2.751-.337 3.57-1.68.343-.554.567-1.155.749-1.792-.301.168-.581.343-.882.476-1.372.595-2.806.805-4.27.448-1.966-.476-3.177-1.771-3.73-3.689-.385-1.322-.308-2.666.007-3.989.343-1.435 1.001-2.708 2.037-3.765 1.162-1.19 2.569-1.918 4.22-2.142 1.17-.16 2.303-.042 3.381.462q.943.44 1.644 1.225c.05.049.092.098.162.175.078-.198.156-.428.235-.666a1.73 1.73 0 0 1 1.666-1.19h1.064a1.39 1.39 0 0 1 1.363 1.68c-.11.511-.223 1.032-.304 1.387q-1.048 4.567-2.107 9.133c-.315 1.365-.784 2.666-1.526 3.863-1.217 1.967-2.981 3.114-5.263 3.457-1.463.217-2.918.203-4.34-.252a6 6 0 0 1-2.916-1.914m7.508-6.792c.21-.028.427-.042.637-.084.91-.196 1.554-.77 2.023-1.54.525-.853.777-1.805.847-2.799a3.25 3.25 0 0 0-.182-1.393c-.441-1.182-1.547-1.567-2.68-1.434-.84.098-1.513.532-2.03 1.182-.89 1.12-1.225 2.415-1.072 3.815.147 1.413 1.085 2.24 2.457 2.253M116.899 17.178c.973 0 2.183.217 3.296.825 1.596.868 2.583 2.22 2.898 3.99.49 2.75-.161 5.235-2.051 7.327-1.183 1.316-2.709 2.05-4.437 2.373-1.337.252-2.674.266-4.004-.07-1.665-.42-3.016-1.295-3.898-2.814-.56-.966-.791-2.022-.791-3.128.007-1.722.427-3.331 1.33-4.801 1.155-1.876 2.848-2.982 4.983-3.45.791-.175 1.582-.245 2.674-.252m1.798 6.242c-.042-.385-.07-.776-.14-1.161-.105-.581-.315-1.113-.769-1.512-.623-.553-1.372-.658-2.163-.51-.84.16-1.463.657-1.925 1.35-1.05 1.588-1.344 3.338-1.036 5.193.091.574.329 1.105.77 1.497.756.665 1.638.707 2.541.392.819-.287 1.372-.91 1.792-1.644.643-1.113.888-2.324.93-3.605M77.145 31.617a1.167 1.167 0 0 1-1.137-1.417c.844-3.847 1.688-7.812 2.528-11.648a1.63 1.63 0 0 1 1.59-1.278h1.083c.771 0 1.318.619 1.21 1.382-.028.188-.046.37-.046.537.084-.063.133-.098.175-.133 1.196-1.008 2.561-1.645 4.122-1.833.938-.113 1.862-.064 2.758.265 1.14.42 1.805 1.253 2.057 2.429.217 1.015.126 2.023-.084 3.016-.483 2.3-1.111 5.48-1.554 7.436a1.56 1.56 0 0 1-1.538 1.208h-1.773a1.16 1.16 0 0 1-1.133-1.413l.048-.215c.496-2.223.997-4.442 1.485-6.666.112-.51.161-1.035.021-1.56-.161-.602-.588-.966-1.21-1.015-1.373-.12-2.422.44-3.178 1.567-.504.756-.756 1.61-.938 2.485q-.583 2.744-1.173 5.492l-.02.093a1.62 1.62 0 0 1-1.589 1.27z"
            ></path>
            <defs>
              <linearGradient
                id="svg-3937310671__a"
                x1="38.076"
                x2="23.32"
                y1="14.964"
                y2="18.61"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FD00CF"></stop>
                <stop offset="1" stopColor="#FD00CF"></stop>
              </linearGradient>
              <linearGradient
                id="svg-3937310671__b"
                x1="15.072"
                x2="36.832"
                y1="7.573"
                y2="41.493"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.066" stopColor="#FF0451"></stop>
                <stop offset="0.207" stopColor="#FF006A"></stop>
                <stop offset="0.378" stopColor="#FC1FA4"></stop>
                <stop offset="0.544" stopColor="#FE00CF"></stop>
                <stop offset="0.816" stopColor="#B30CE4"></stop>
                <stop offset="1" stopColor="#8204FF"></stop>
              </linearGradient>
              <linearGradient
                id="svg-3937310671__c"
                x1="10.75"
                x2="31.095"
                y1="17.813"
                y2="25.462"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stopColor="#92077F" stopOpacity="0"></stop>
                <stop offset="0.285" stopColor="#8D067D"></stop>
                <stop offset="0.678" stopColor="#8D008C"></stop>
                <stop offset="0.912" stopColor="#8E067E" stopOpacity="0"></stop>
              </linearGradient>
              <linearGradient
                id="svg-3937310671__d"
                x1="10.75"
                x2="31.095"
                y1="17.813"
                y2="25.462"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.065" stopColor="#92077F" stopOpacity="0"></stop>
                <stop offset="0.285" stopColor="#8D067D"></stop>
                <stop offset="0.678" stopColor="#8D008C"></stop>
                <stop offset="0.912" stopColor="#8E067E" stopOpacity="0"></stop>
              </linearGradient>
            </defs>
          </svg>
        </a>
        <Select
          className="app-header-select"
          defaultValue={selectedOption}
          onChange={onChangeHandle}
          options={options}
          value={selectedOption}
        />
      </div>
    </header>
  );
};

export default memo(Header);
